"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextVersion = nextVersion;
function nextVersion(increment, version = '0.0.0', tag) {
    let [_v, _t] = version.split('-');
    if (tag) {
        _t = tag;
    }
    let [major = 0, minor = 0, patch = 0] = _v.split('.').map((v) => parseInt(v) || 0);
    if (increment === 'major') {
        major = major + 1;
        minor = 0;
        patch = 0;
    }
    if (increment === 'minor') {
        minor = minor + 1;
        patch = 0;
    }
    if (increment === 'patch') {
        patch = patch + 1;
    }
    let v = [major, minor, patch].join('.');
    if (_t) {
        v = [v, _t].join('-');
    }
    return v;
}
//# sourceMappingURL=version.js.map